/* Flower Delivery Dubai — engagement layer: scroll reveal, card hover zoom, same-day countdown bar */
(function () {
  "use strict";

  var CSS = [
    /* scroll reveal */
    '#MainContent .shopify-section.fdd-reveal{opacity:0;transform:translateY(28px);will-change:opacity,transform;}',
    '#MainContent .shopify-section.fdd-reveal.fdd-in{opacity:1;transform:none;transition:opacity .7s ease,transform .8s cubic-bezier(.16,.7,.2,1);}',
    /* product card image zoom on hover */
    '.hdt-card-product__media,.hdt-card-product .hdt-media,.hdt-card-product__image{overflow:hidden;}',
    '.hdt-card-product__media img,.hdt-card-product .hdt-media img,.hdt-card-product__image img{transition:transform .6s cubic-bezier(.2,.7,.2,1);}',
    '.hdt-card-product:hover .hdt-card-product__media img,.hdt-card-product:hover .hdt-media img,.hdt-card-product:hover .hdt-card-product__image img{transform:scale(1.06);}',
    /* countdown bar */
    '.fdd-cd{display:flex;align-items:center;justify-content:center;gap:9px;background:linear-gradient(90deg,#f7efe0,#f4ead6,#f7efe0);color:#2b2a28;font-size:13.5px;letter-spacing:.02em;line-height:1.3;padding:9px 42px 9px 18px;position:relative;text-align:center;border-bottom:1px solid #e0d2b8;}',
    '.fdd-cd strong{color:#8a6a34;font-weight:700;font-variant-numeric:tabular-nums;}',
    '.fdd-cd__x{position:absolute;right:12px;top:50%;transform:translateY(-50%);background:none;border:0;font-size:17px;line-height:1;color:#7c7367;cursor:pointer;opacity:.55;padding:4px;}',
    '.fdd-cd__x:hover{opacity:1;}',
    '@media (max-width:600px){.fdd-cd{font-size:12px;padding:8px 36px 8px 12px;}}',
    '@media (prefers-reduced-motion: reduce){#MainContent .shopify-section.fdd-reveal{opacity:1!important;transform:none!important;}.hdt-card-product__media img,.hdt-card-product .hdt-media img{transition:none!important;}}'
  ].join('');

  function injectCss() {
    var s = document.createElement('style');
    s.id = 'fdd-animate-css';
    s.appendChild(document.createTextNode(CSS));
    document.head.appendChild(s);
  }

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setupReveal() {
    if (reduce) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = Array.prototype.slice.call(main.querySelectorAll('.shopify-section'));
    if (!sections.length) return;
    // skip the first section (hero / above-the-fold) so nothing important starts hidden
    var targets = sections.slice(1);
    if (!('IntersectionObserver' in window)) return; // no observer -> leave everything visible

    targets.forEach(function (el) { el.classList.add('fdd-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('fdd-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < (window.innerHeight || 800) * 0.92) {
        el.classList.add('fdd-in'); // already in view on load
      } else {
        io.observe(el);
      }
    });

    // failsafe: never leave content hidden
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('fdd-in'); });
    }, 2600);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function dubaiNow() {
    // Dubai is UTC+4 year-round (no DST)
    return new Date(Date.now() + 4 * 3600000);
  }

  function cutdownText() {
    var d = dubaiNow();
    var sec = d.getUTCHours() * 3600 + d.getUTCMinutes() * 60 + d.getUTCSeconds();
    var cutoff = 22 * 3600; // 10pm Dubai
    if (sec < cutoff) {
      var rem = cutoff - sec;
      var h = Math.floor(rem / 3600);
      var m = Math.floor((rem % 3600) / 60);
      var s = rem % 60;
      var t = (h > 0 ? h + 'h ' : '') + pad(m) + 'm ' + pad(s) + 's';
      return '🌹 Order within <strong>' + t + '</strong> for same-day flower delivery in Dubai';
    }
    return '🌸 Same-day cutoff reached — order now for early delivery tomorrow across Dubai';
  }

  function setupCountdown() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    try { if (sessionStorage.getItem('fddCdClosed') === '1') return; } catch (e) {}

    var bar = document.createElement('div');
    bar.className = 'fdd-cd';
    bar.setAttribute('role', 'status');
    bar.setAttribute('aria-live', 'polite');

    var txt = document.createElement('span');
    txt.className = 'fdd-cd__txt';
    txt.innerHTML = cutdownText();

    var x = document.createElement('button');
    x.className = 'fdd-cd__x';
    x.type = 'button';
    x.setAttribute('aria-label', 'Dismiss');
    x.innerHTML = '×';
    x.addEventListener('click', function () {
      bar.parentNode && bar.parentNode.removeChild(bar);
      try { sessionStorage.setItem('fddCdClosed', '1'); } catch (e) {}
      clearInterval(timer);
    });

    bar.appendChild(txt);
    bar.appendChild(x);
    main.insertBefore(bar, main.firstChild);

    var timer = setInterval(function () {
      txt.innerHTML = cutdownText();
    }, 1000);
  }

  function init() {
    injectCss();
    setupReveal();
    setupCountdown();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Flower Delivery Dubai — BSS options: align date/time/message + hide past time slots by Dubai time */
(function () {
  "use strict";

  var CSS = [
    '[id^="po_container--"]{max-width:100%;}',
    '[id^="po_container--"] > *{margin-bottom:14px;}',
    '[id^="po_container--"] label{display:block!important;font-weight:600;font-size:14px;line-height:1.6!important;height:auto!important;min-height:0!important;max-height:none!important;overflow:visible!important;white-space:normal!important;padding:2px 0!important;margin:0 0 6px;color:#2b2a28;}',
    '[id^="po_container--"] select,[id^="po_container--"] input[type="text"],[id^="po_container--"] input[type="date"],[id^="po_container--"] input[type="tel"],[id^="po_container--"] input[type="email"],[id^="po_container--"] input:not([type]),[id^="po_container--"] textarea,[id^="po_container--"] .flatpickr-input{width:100%!important;box-sizing:border-box!important;border:1px solid #e0d2b8!important;border-radius:10px!important;padding:11px 14px!important;font-size:14px!important;background:#fff!important;color:#2b2a28!important;line-height:1.4!important;}',
    '[id^="po_container--"] .flatpickr-input,[id^="po_container--"] input.fdd-dateicon{padding-left:42px!important;}',
    '[id^="po_container--"] select:focus,[id^="po_container--"] input:focus,[id^="po_container--"] textarea:focus{border-color:#8a6a34!important;outline:none!important;box-shadow:0 0 0 3px rgba(176,141,87,.15)!important;}',
    '[id^="po_container--"] textarea{min-height:88px;resize:vertical;}',
    '[id^="po_container--"] option:disabled{color:#c2b9a8;}',
    '.fdd-slot-hidden{display:none!important;}',
    '.fdd-slot-past{opacity:.38!important;pointer-events:none!important;cursor:not-allowed!important;text-decoration:line-through;}'
  ].join('');

  function injectCss() {
    if (document.getElementById('fdd-bss-css')) return;
    var s = document.createElement('style');
    s.id = 'fdd-bss-css';
    s.appendChild(document.createTextNode(CSS));
    (document.head || document.documentElement).appendChild(s);
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function dubaiDate() { return new Date(Date.now() + 4 * 3600000); }
  function dubaiTodayStr() { var d = dubaiDate(); return pad(d.getUTCDate()) + '-' + pad(d.getUTCMonth() + 1) + '-' + d.getUTCFullYear(); }
  function dubaiNowMin() { var d = dubaiDate(); return d.getUTCHours() * 60 + d.getUTCMinutes(); }

  // parse the START time (in minutes from midnight) from a slot label like "9:00 AM - 10:00 AM"
  function startMinutes(txt) {
    if (!txt) return null;
    var m = txt.match(/(\d{1,2}):(\d{2})\s*(a|p)\.?m/i);
    if (m) { var h = (+m[1]) % 12; if (/p/i.test(m[3])) h += 12; return h * 60 + (+m[2]); }
    m = txt.match(/(\d{1,2})\s*(a|p)\.?m/i);
    if (m) { var h2 = (+m[1]) % 12; if (/p/i.test(m[2])) h2 += 12; return h2 * 60; }
    return null;
  }
  function isTimeText(t) { return !!t && /\d{1,2}(:\d{2})?\s*(a|p)\.?m/i.test(t) && /[-–]|to/i.test(t); }

  function findContainer() { return document.querySelector('[id^="po_container--"]'); }

  function findDateValue(c) {
    var ins = c.querySelectorAll('input');
    for (var i = 0; i < ins.length; i++) {
      var v = (ins[i].value || '').trim();
      if (/^\d{2}-\d{2}-\d{4}$/.test(v)) return v;
    }
    return '';
  }

  // give the date field extra left padding so its calendar icon doesn't overlap the text
  function tagDateInputs(c) {
    Array.prototype.forEach.call(c.querySelectorAll('input'), function (inp) {
      var ph = inp.getAttribute('placeholder') || '';
      var v = (inp.value || '').trim();
      if (/date/i.test(ph) || /^\d{2}-\d{2}-\d{4}$/.test(v) || /flatpickr/.test(inp.className || '')) {
        inp.classList.add('fdd-dateicon');
      }
    });
  }

  function filter() {
    var c = findContainer();
    if (!c) return;
    var today = dubaiTodayStr();
    var dv = findDateValue(c);
    var isToday = !!dv && dv === today;
    var now = dubaiNowMin();

    // 1) native <select> time slots
    var selects = c.querySelectorAll('select');
    Array.prototype.forEach.call(selects, function (sel) {
      var opts = sel.options, looksTime = false, i;
      for (i = 0; i < opts.length; i++) { if (isTimeText(opts[i].text)) { looksTime = true; break; } }
      if (!looksTime) return;
      var changed = false;
      for (i = 0; i < opts.length; i++) {
        var st = startMinutes(opts[i].text);
        if (st === null) { opts[i].disabled = false; continue; }
        var past = isToday && st <= now;
        opts[i].disabled = past;
        if (past && sel.selectedIndex === i) changed = true;
      }
      if (changed) {
        var idx = -1;
        for (var k = 0; k < opts.length; k++) { if (!opts[k].disabled) { idx = k; if (opts[k].value) break; } }
        sel.selectedIndex = idx >= 0 ? idx : 0;
        try { sel.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
      }
    });

    // 2) radio time slots
    var radios = c.querySelectorAll('input[type="radio"]');
    Array.prototype.forEach.call(radios, function (r) {
      var lbl = r.closest('label') || (r.id ? c.querySelector('label[for="' + r.id + '"]') : null);
      var txt = lbl ? lbl.textContent : '';
      if (!isTimeText(txt)) return;
      var st = startMinutes(txt);
      var past = isToday && st !== null && st <= now;
      r.disabled = past;
      var wrap = r.closest('.po_element') || lbl || r.parentNode;
      if (wrap && wrap !== c) { wrap.classList[past ? 'add' : 'remove']('fdd-slot-hidden'); }
      if (past && r.checked) { r.checked = false; try { r.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {} }
    });

    // 3) BSS custom dropdown option rows (ul>li / [role=option])
    var items = c.querySelectorAll('li,[role="option"]');
    Array.prototype.forEach.call(items, function (el) {
      if (el.querySelector && el.querySelector('li,[role="option"]')) return; // container, not a leaf option
      var txt = (el.textContent || '').trim();
      if (!isTimeText(txt)) return;
      var st = startMinutes(txt);
      var past = isToday && st !== null && st <= now;
      el.classList[past ? 'add' : 'remove']('fdd-slot-past');
      if (past) { el.setAttribute('aria-disabled', 'true'); } else { el.removeAttribute('aria-disabled'); }
    });
  }

  function bindInputs() {
    var c = findContainer();
    if (!c) return;
    Array.prototype.forEach.call(c.querySelectorAll('input'), function (inp) {
      if (inp.__fddBssBound) return;
      inp.__fddBssBound = true;
      inp.addEventListener('change', filter);
      inp.addEventListener('input', filter);
    });
  }

  function run() {
    injectCss();
    var c = findContainer();
    if (c) tagDateInputs(c);
    bindInputs();
    filter();
  }

  function init() {
    run();
    var t;
    var mo = new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 250); });
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    // BSS renders asynchronously — re-run a few times after load
    var n = 0, iv = setInterval(function () { run(); if (++n > 20) clearInterval(iv); }, 1200);
    // re-check every minute so a slot disables itself as its time passes
    setInterval(filter, 60000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
